import { render, staticRenderFns } from "./templatesView.vue?vue&type=template&id=58de8a23&scoped=true&"
import script from "./templatesView.vue?vue&type=script&lang=js&"
export * from "./templatesView.vue?vue&type=script&lang=js&"
import style0 from "./templatesView.vue?vue&type=style&index=0&id=58de8a23&prod&lang=scss&scoped=true&"
import style1 from "./templatesView.vue?vue&type=style&index=1&id=58de8a23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de8a23",
  null
  
)

export default component.exports